import { gql, type Variables } from 'graphql-request';

import { getQueryClient } from '@/api/queryClient';
import gqlRequest from '@/utils/gqlRequest';

import {
  getCartIdCookie,
  invalidateCartData,
  saveCartIdCookie,
} from '../utils/cartUtils';
import type {
  RemoveFromCart,
  RemoveFromCart_cart_removeLineItem,
  RemoveFromCartVariables,
} from './types/RemoveFromCart';

export type RemoveLineItemResult = RemoveFromCart_cart_removeLineItem;

export const query = gql`
  query RemoveFromCart($cartId: String, $skuCode: String!, $parentId: String) {
    cart(cartId: $cartId) {
      removeLineItem(skuCode: $skuCode, parentId: $parentId) {
        cartId
        resultCategory
        errorCode
        invalidReason
      }
    }
  }
`;

export function withQueryKey(req: RemoveFromCartVariables) {
  return {
    queryKey: ['removeFromCart', req.cartId, req.skuCode, req.parentId],
    queryFn: async () => {
      try {
        const response = await gqlRequest<RemoveFromCart>(
          query,
          req as unknown as Variables,
        );
        const removeResult = response.cart?.removeLineItem;

        if (
          removeResult?.cartId &&
          (!removeResult.invalidReason || !removeResult.errorCode)
        ) {
          saveCartIdCookie(removeResult.cartId);
        }

        invalidateCartData();

        return removeResult;
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('RemoveFromCart failed', err);
        return null;
      }
    },
  };
}

export async function removeFromCart(
  skuCode: string,
  parentId: string | null,
): Promise<RemoveLineItemResult> {
  const cartId = getCartIdCookie();
  const queryClient = getQueryClient();

  return queryClient.fetchQuery({
    ...withQueryKey({ cartId, skuCode, parentId }),
  });
}
